import { Injectable } from '@angular/core';

@Injectable()
export class GTagService {

  triggerFormLink(name: string, isValid: string, incorrectFields: string) {
    const formLinkFun = window['formLink'];
    if (formLinkFun) {
      formLinkFun(name, isValid, incorrectFields);
    }
  }

  triggerPopupView(name: string) {
    const popupViewFun = window['popupView'];
    if (popupViewFun) {
      popupViewFun(name);
    }
  }
}
